import React from "react";
import { Link } from "react-router-dom";
import {
  Instagram,
  Facebook,
  Linkedin,
  Youtube,
  MessageCircle,
  Globe,
  Phone,
  Mail,
  MapPin,
  ArrowUpRight,
  type LucideIcon,
} from "lucide-react";

const pages = [
  { title: "Home", path: "/" },
  { title: "About", path: "/about_me" },
  { title: "Recognition & Impact", path: "/recognition" },
  { title: "Blog", path: "/blog" },
  { title: "Connect", path: "/connect_me" },
];

const socials: { Icon: LucideIcon; label: string; href: string }[] = [
  { Icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/devyansh-agrawal/" },
  { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/devyansh_agrawal_/" },
  { Icon: Facebook, label: "Facebook", href: "https://www.facebook.com/devyansh.agarwal.75" },
  { Icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@devyanshagrawal8882" },
  { Icon: MessageCircle, label: "WhatsApp", href: "https://wa.link/srz7dg" },
  { Icon: Globe, label: "DevAnanta", href: "https://devananta.com/" },
];

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-white/10 bg-ink-950">
      <div className="container mx-auto py-16">
        <div className="grid gap-12 md:grid-cols-3">
          {/* Brand + venture */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-brand-500 font-display text-base font-bold text-ink-950">
                DA
              </span>
              <span className="font-display text-lg font-semibold text-white">
                Devyansh Agrawal
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-400">
              Scientist and entrepreneur turning waste into clean energy — for an
              India that powers itself.
            </p>
            <a
              href="https://devananta.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-400 hover:text-brand-300"
            >
              Founder of DevAnanta R&D <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">
              Explore
            </h3>
            <ul className="mt-5 space-y-3">
              {pages.map((p) => (
                <li key={p.path}>
                  <Link
                    to={p.path}
                    className="text-sm text-zinc-300 transition-colors hover:text-brand-400"
                  >
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">
              Get in touch
            </h3>
            <ul className="mt-5 space-y-3 text-sm text-zinc-300">
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-brand-400" />
                <a href="mailto:devyansh@devananta.com" className="hover:text-brand-400">
                  devyansh@devananta.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-brand-400" /> +91 82101 52465
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-brand-400" /> Bengaluru, India
              </li>
            </ul>

            <div className="mt-6 flex flex-wrap gap-2.5">
              {socials.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:border-brand-500/50 hover:text-brand-400"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-zinc-500 sm:flex-row">
          <p>© {new Date().getFullYear()} Devyansh Agrawal. All rights reserved.</p>
          <p>Building a cleaner, self-reliant Bharat. 🌱</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
